import { mapState } from 'vuex';
import { paths } from '@/router/routes';
import PermissionTypes from '@/enums/permissions';
import store from '@/store';

export default {
  data() {
    return {};
  },

  computed: {
    userInfo() {
      return (this.user && this.user.info) || null;
    },
    permissions() {
      return (this.user && this.user.permissions) || [];
    },
    canCreateOrders() {
      return this.hasPermission(PermissionTypes.createOrders);
    },
    canViewUsers() {
      return this.hasPermission(PermissionTypes.manageUsers);
    },
    canInviteUsers() {
      return this.hasPermission(PermissionTypes.inviteUsers);
    },
    canViewInvoices() {
      return this.hasPermission(PermissionTypes.viewInvoices);
    },
    canViewInvoicesPaymentStatus() {
      return this.hasPermission(PermissionTypes.invoicesPaymentStatus);
    },
    ...mapState({
      user: state => state.user,
      authenticating: state => state.user.authenticating,
    }),
  },
  methods: {
    hasPermission(type) {
      return (
        this.permissions &&
        Array.isArray(this.permissions) &&
        this.permissions.includes(type)
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    const permissions = store.state.user.permissions;

    // Block invoices if user is not permitted to view them
    if (
      to.path === paths.invoices &&
      !permissions.includes(PermissionTypes.viewInvoices)
    ) {
      return;
    }

    // Block users if user is not permitted to view them
    if (
      to.path === paths.users &&
      !permissions.includes(PermissionTypes.manageUsers)
    ) {
      return;
    }

    next();
  },
};
